import {IrsaliyeOlusturRequestKalem} from './irsaliye-olustur-request-kalem';

export class IrsaliyeOlusturRequest {
  id: number;
  irsaliyeNo: string;
  irsaliyeNotu: string;
  irsaliyeTarihi: Date;
  siparisId: number;
  irsaliyeKalemler: IrsaliyeOlusturRequestKalem[];


}
